module.exports = __webpack_public_path__ + "static/img/menage4.74067e5f.jpg";